<template>
  <div class="logout" data-remote="true">
    <div v-if="(notLoggedTitle != '' || notLoggedDesc != '') && isMobile" class="login-message">
      <span class="title">{{ notLoggedTitle }}</span>
      <span class="desc">{{ notLoggedDesc }}</span>
    </div>
    <!-- .message -->
    <div class="info-login-content">
      <div class="info-login-content__left">
        <span class="s s-user_rounded" :class="{ 's-m': isMobile, 's-xxl c-black mb-3': !isMobile }"></span>
        <span class="name c-dark-grey t-label">{{ title }}</span>
      </div>
      <div class="info-login-content__right">
        <button
          type="button"
          class="btn-primary info-login-content__login-cta utag-ib-register"
          data-utag-ib-register-type="header"
          @click="showLoginSSO"
        >
          {{ loginText }}
        </button>
      </div>
    </div>
  </div>
  <!-- .logout -->
</template>
<script>
import { auth0Login } from '../../../../auth0/sso'
import { currentDevice } from '../../../../core/utils/currentDevice'
import loaderSpinner from '../../../../shared/loader_spinner/loader_spinner'

const componentName = 'NotLogged'
export default {
  name: componentName,
  props: {
    notLoggedTitle: String,
    notLoggedDesc: String,
    title: String,
    loginText: String,
  },
  computed: {
    isMobile() {
      return currentDevice.isMobile
    },
  },
  methods: {
    showLoginSSO() {
      loaderSpinner.show()
      auth0Login(false)
    },
  },
}
</script>
